import { render } from "./ExternalVmsPage.vue?vue&type=template&id=790c1193&ts=true"
import script from "./ExternalVmsPage.vue?vue&type=script&lang=tsx"
export * from "./ExternalVmsPage.vue?vue&type=script&lang=tsx"

import "./ExternalVmsPage.vue?vue&type=style&index=0&id=790c1193&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__